import { ViewModeType } from "../generated/interface"
import { Gesture } from "./BaseGesture"

export default function () {
  const { getCollectionViewFileFromEvent, isPrimaryClick, isOverCollectionView, gestureLayers } = useGestures()
  const { currentOpenFolders } = useNavigation()

  const { collectionTreeChevronClass: mainViewTreeChevronClass } = useGlobals()
  const { emitInterfaceEvent } = useEvents()
  const { state: viewModeState } = useViewMode()

  class TreeViewClickToExpandFolder extends Gesture {
    override layer = gestureLayers.viewMode

    #didClickChevron = false

    override reset() {
      this.#didClickChevron = false
    }

    wasChevronClick(mouse: MouseEvent) {
      return !!getFirstMatchingParent(
        mouse.target,
        t => !!t.classList?.contains(mainViewTreeChevronClass),
      )
    }

    override async onMouseDown(mouse: MouseEvent) {
      if (
        !isPrimaryClick(mouse)
        || !isOverCollectionView(mouse)
        || !enumEq(viewModeState.value.current.mode, ViewModeType.Tree)
      )
        return

      const folder = getCollectionViewFileFromEvent(mouse)
      if (!folder || !this.wasChevronClick(mouse))
        return

      this.capture()
      this.debug("Clicked on chevron for file, toggling", folder)
      this.#didClickChevron = true

      if (currentOpenFolders.value[folder.id]) {
        emitInterfaceEvent("afterShrunkFolder", folder as StaticFile)
      }
      else {
        emitInterfaceEvent("afterExpandedFolder", folder as StaticFile)
      }
    }

    override async onMouseUp(_mouse: MouseEvent) {
      if (this.#didClickChevron)
        this.capture()
      return this.reset()
    }
  }
  return new TreeViewClickToExpandFolder()
}
